import _decorate from "@babel/runtime/helpers/esm/decorate";
import { html, property } from 'lit-element';
import { KatLitElement, register } from '../shared/base';
import { checkSlots } from '../shared/slot-utils';
import baseStyles from "../shared/base/base.lit.css.js";
import _styles from "./progress.lit.css.js";
import getString from './strings';
export let KatProgress = _decorate([register('kat-progress')], function (_initialize, _KatLitElement) {
  class KatProgress extends _KatLitElement {
    constructor(...args) {
      super(...args);
      _initialize(this);
    }
  }
  return {
    F: KatProgress,
    d: [{
      kind: "field",
      decorators: [property({
        attribute: 'start-value',
        type: Number
      })],
      key: "startValue",
      value: void 0
    }, {
      kind: "field",
      decorators: [property({
        attribute: 'end-value',
        type: Number
      })],
      key: "endValue",
      value: void 0
    }, {
      kind: "field",
      decorators: [property({
        type: Number
      })],
      key: "value",
      value: void 0
    }, {
      kind: "field",
      decorators: [property()],
      key: "type",
      value() {
        return 'linear';
      }
    }, {
      kind: "field",
      decorators: [property()],
      key: "size",
      value() {
        return 'medium';
      }
    }, {
      kind: "field",
      decorators: [property()],
      key: "state",
      value() {
        return 'working';
      }
    }, {
      kind: "field",
      decorators: [property({
        type: Boolean
      })],
      key: "indeterminate",
      value() {
        return false;
      }
    }, {
      kind: "field",
      decorators: [property({
        attribute: 'hide-value',
        type: Boolean
      })],
      key: "hideValue",
      value() {
        return false;
      }
    }, {
      kind: "field",
      decorators: [property({
        attribute: 'kat-aria-label'
      })],
      key: "katAriaLabel",
      value: void 0
    }, {
      kind: "field",
      decorators: [property()],
      key: "locale",
      value: void 0
    }, {
      kind: "get",
      static: true,
      key: "styles",
      value: function styles() {
        return [baseStyles, _styles];
      }
    }, {
      kind: "field",
      key: "_svgBox",
      value() {
        return 20;
      }
    }, {
      kind: "method",
      key: "_getStartValue",
      value: function _getStartValue() {
        return !isNaN(this.startValue) ? this.startValue : 0;
      }
    }, {
      kind: "method",
      key: "_getEndValue",
      value: function _getEndValue() {
        return !isNaN(this.endValue) ? this.endValue : this._getStartValue() + 100;
      }
    }, {
      kind: "method",
      key: "_getValue",
      value: function _getValue() {
        const start = this._getStartValue();
        const end = this._getEndValue();
        const val = !isNaN(this.value) ? this.value : start;
        return this._isRangeReversed ? val > start ? start : val < end ? end : val : val < start ? start : val > end ? end : val;
      }
    }, {
      kind: "get",
      key: "_isRangeReversed",
      value: function _isRangeReversed() {
        return this._getStartValue() > this._getEndValue();
      }
    }, {
      kind: "get",
      key: "_cssIndeterminate",
      value: function _cssIndeterminate() {
        return this.indeterminate ? 'indeterminate' : '';
      }
    }, {
      kind: "get",
      key: "_cssProgression",
      value: function _cssProgression() {
        return this.indeterminate ? '' : `width:${this.progression}%`;
      }
    }, {
      kind: "get",
      key: "_isWorking",
      value: function _isWorking() {
        return this.state === 'working';
      }
    }, {
      kind: "get",
      key: "_cssValue",
      value: function _cssValue() {
        return this.indeterminate || !this._isWorking || this.hideValue ? 'hidden' : '';
      }
    }, {
      kind: "get",
      key: "_cssIcon",
      value: function _cssIcon() {
        return !this._isWorking ? '' : 'hidden';
      }
    }, {
      kind: "get",
      key: "_cssLabel",
      value: function _cssLabel() {
        const slots = checkSlots(this);
        return slots.label ? '' : 'hidden';
      }
    }, {
      kind: "get",
      key: "_iconName",
      value: function _iconName() {
        switch (this.state) {
          case 'error':
            return 'error';
          case 'warning':
            return 'warning';
          case 'success':
            return 'checkmark-circle-fill';
          default:
            return '';
        }
      }
    }, {
      kind: "method",
      key: "_childrenChanged",
      value: function _childrenChanged() {
        this.requestUpdate();
      }
    }, {
      kind: "get",
      key: "_size",
      value: function _size() {
        return this.size === 'small' || this.size === 'large' ? this.size : 'medium';
      }
    }, {
      kind: "get",
      key: "_unroundedProgression",
      value: function _unroundedProgression() {
        const start = this._getStartValue();
        const end = this._getEndValue();
        const val = this._getValue();
        return this._isRangeReversed ? (start - val) / (start - end) * 100 : (val - start) / (end - start) * 100;
      }
    }, {
      kind: "get",
      key: "_circularPath",
      value: function _circularPath() {
        let degree = 3.6 * this._unroundedProgression;
        degree = degree > 359.5 ? 359.5 : degree;
        const rad = (degree - 90) * Math.PI / 180;
        const size = this._svgBox - 2 >> 1;
        const largeArc = degree > 180 ? 1 : 0;
        const edgeOffset = 1;
        const x = edgeOffset + size * (1 + Math.cos(rad));
        const y = edgeOffset + size * (1 + Math.sin(rad));
        return `M${size + edgeOffset} ${edgeOffset} A${size} ${size} 0 ${largeArc} 1 ${x} ${y}`;
      }
    }, {
      kind: "get",
      key: "_circularSVG",
      value: function _circularSVG() {
        const csize = this._svgBox - 2 >> 1;
        const bsize = this._svgBox >> 1;
        return this.indeterminate ? html` <svg viewBox="0 0 ${this._svgBox} ${this._svgBox}" class="indeterminate"> <path d="M${csize} 1 A${csize} ${csize} 0 1 1 1 ${csize}" stroke-linecap="round" class="meter"/> </svg> ` : html` <svg viewBox="0 0 ${this._svgBox} ${this._svgBox}"> <circle cx="${bsize}" cy="${bsize}" r="${csize}" class="track"/> <path d="${this._circularPath}" stroke-linecap="round" class="meter"/> </svg> `;
      }
    }, {
      kind: "get",
      key: "_ariaLabel",
      value: function _ariaLabel() {
        if (!this.katAriaLabel) {
          return getString('kat_progress_label', null, this.locale);
        }
        return this.katAriaLabel;
      }
    }, {
      kind: "get",
      key: "progression",
      value: function progression() {
        return Math.round(this._unroundedProgression);
      }
    }, {
      kind: "method",
      key: "_renderLinear",
      value: function _renderLinear() {
        return html` <div part="linear-wrapper" class="linear-wrapper"> <div part="linear-label" class="linear-label ${this._cssLabel}"> <slot name="label" @slotchange="${this._childrenChanged}"></slot> </div> <div part="linear-bar-and-val" class="linear-bar-and-val"> <div part="linear-bar" class="linear-bar"> <div part="linear-meter" class="linear-meter ${this._cssIndeterminate}" style="${this._cssProgression}"></div> </div> <div part="linear-val" class="linear-val ${this._cssValue}"> ${this.progression}% </div> <div part="linear-icon" class="linear-icon ${this._cssIcon}"> <kat-icon part="icon" name="${this._iconName}" size="small"></kat-icon> </div> </div> </div> `;
      }
    }, {
      kind: "method",
      key: "_renderCircular",
      value: function _renderCircular() {
        return html` <div class="circular-wrapper ${this._size}"> <div part="circular-svg-icon-wrapper" class="circular-svg-icon-wrapper"> <div class="circular-svg-wrapper ${this.state}"> ${this._circularSVG} </div> <div class="circular-icon ${this._cssIcon}"> <kat-icon part="icon" name="${this._iconName}" size="small"></kat-icon> </div> <div part="circular-val" class="circular-val ${this._cssValue}"> ${this.progression}% </div> </div> <div part="circular-label" class="circular-label ${this._cssLabel}"> <slot name="label" @slotchange="${this._childrenChanged}"></slot> </div> </div> `;
      }
    }, {
      kind: "method",
      key: "render",
      value: function render() {
        return this.indeterminate ? html` <div class="progress" aria-live="polite" role="progressbar" aria-label="${this._ariaLabel}"> ${this.type === 'circular' ? this._renderCircular() : this._renderLinear()} </div> ` : html` <div class="progress" aria-live="polite" role="progressbar" aria-valuenow="${this.progression}" aria-label="${this._ariaLabel}"> ${this.type === 'circular' ? this._renderCircular() : this._renderLinear()} </div> `;
      }
    }]
  };
}, KatLitElement);
//# sourceMappingURL=progress.js.map